import { getAdMarketPublishGroupCode, getMarketCountryCode } from './sharedAdsUtils';

// For the following markets, we will have special treatment for the header ad. Make it as a method so that we can adjust market in the future easily.
export default function isHeaderAdSpecialMarket(): boolean {
    return getMarketCountryCode(getAdMarketPublishGroupCode()) == 'FR';
}
